module.exports = __webpack_public_path__ + "img/pay-with-cash.ec36c0cc.png";